import type { DocumentType } from './enums.js';

export const LEGAL_DOCUMENT_TYPES = [
  'patta',
  'chitta',
  'parent_doc',
  'rsr',
  'adangal',
  'topo',
  'original_doc',
  'ec'
] as const satisfies readonly DocumentType[];

export const REQUIRED_DOCUMENT_TYPES = [
  'patta',
  'chitta',
  'parent_doc'
] as const satisfies readonly DocumentType[];

export const SUPPORTING_DOCUMENT_TYPES = [
  'aadhaar',
  'pan',
  'noc',
  'court_order'
] as const satisfies readonly DocumentType[];

const REQUIRED_SET: ReadonlySet<DocumentType> = new Set(REQUIRED_DOCUMENT_TYPES);

export const isRequiredDocumentType = (type: DocumentType): boolean => REQUIRED_SET.has(type);

export const ADDITIONAL_DOCUMENT_TYPE = 'other' satisfies DocumentType;

export const MAX_ADDITIONAL_DOCUMENTS = 10;
